export class FiltrosRepContabilidad{
   
    Usuario : string ='';
    Estado: string = '';
    Tipo: string = 'factura_generada';
 
 }